import React from "react";
import { Droppable } from "react-beautiful-dnd";
import styled from "styled-components";

interface IResourceListProps {
    day: number;
    track: string;
}

const ResourceListContainer = styled.div`
    background: white;
    border: lightgrey 1px solid;
    border-radius: 4px;
    width: 100%;
    height: 100%;
`;

export const ResourceList = (props: IResourceListProps) => {
    const droppableId = `resource-list:${props.track}:${props.day}`;
    const type = `resources:${props.day}`;

    return (
        <Droppable droppableId={droppableId} direction="vertical" type={type}>
            {provided => (
                <ResourceListContainer
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                />
            )}
        </Droppable>
    );
};
